import Collection from '@model-core/core/Collection';
import type AbstractModel from '@model-core/core/AbstractModel';

/** Chemin d'une relation à résoudre, du plus proche au plus lointain : ['member', 'user'] */
export type ResolvablePath = readonly string[];

/**
 * Résout des relations de modèles déjà chargés, comme les contrôleurs du site public jts : model-core
 * (Collection.fetchResolvable) fait une requête GET ?id[]=… par niveau, sans doublon, et remplit les modèles liés
 * (@doc.model). Pour les pages de listPage, qui ne passent pas par une Collection ; ailleurs, appeler
 * collection.fetchResolvable() ou model.fetchResolvable() directement. Une relation refusée ou en erreur reste réduite à
 * son identité (ses getters rendent leur valeur par défaut) : la liste s'affiche quand même.
 */
export async function resolveRelations<M extends AbstractModel>(models: M[], paths: readonly ResolvablePath[]) {
  if (!models.length) return;
  const collection = new Collection(models[0].constructor as ModelConstructor).setModels(models as never);
  // Un chemin après l'autre : le cache de la collection évite de redemander un niveau commun (member, puis member.user)
  for (const path of paths) {
    try {
      await (collection.fetchResolvable as (...names: string[]) => Promise<unknown>)(...path);
    } catch {
      // relation non lisible : affichée sans ses champs
    }
  }
}
